import { LoggerConfig, LogLevel } from '../shared/services/logger-config';
export const logConfig: LoggerConfig = {
    enableColors: false,
    defaultLevel: LogLevel.ERROR
};
